import { ArrowLeft, ArrowUpRight, Code2, Cpu, Database, Globe2, Layers3, Network, Server } from "lucide-react";
import React from "react";

const servers = [
  { name: "web-01", role: "Web", cpu: "2 vCPU", ram: "4 GiB RAM", Icon: Globe2, path: "M270 0V24Q270 34 260 34H96Q86 34 86 44V82" },
  { name: "app-01", role: "Aplikace", cpu: "4 vCPU", ram: "8 GiB RAM", Icon: Server, path: "M270 0V82" },
  { name: "db-01", role: "Databáze", cpu: "2 vCPU", ram: "4 GiB RAM", Icon: Database, path: "M270 0V24Q270 34 280 34H444Q454 34 454 44V82" },
];

export function CloudHeroVisual() {
  return (
    <div className="cloud-stage" data-cloud-scene>
      <figure className="cloud-scene" aria-labelledby="cloud-scene-caption">
        <div className="cloud-scene__heading">
          <span><span className="cloud-scene__status" /> Vaše virtuální infrastruktura</span>
          <span className="cloud-scene__region">CZ</span>
        </div>

        <div className="cloud-scene__views">
          <div className="cloud-topology">
            <div className="cloud-topology__internet"><Globe2 aria-hidden="true" /><span>Veřejná síť <strong>IPv4 / IPv6</strong></span></div>
            <svg className="cloud-topology__connections" viewBox="0 0 540 82" preserveAspectRatio="none" fill="none" aria-hidden="true">
              {servers.map(({ name, path }) => (
                <g className="cloud-route" data-cloud-route={name} key={name}>
                  <path className="cloud-wire" d={path} />
                  <path className="cloud-wire cloud-wire--signal" d={path} />
                </g>
              ))}
              <circle cx="270" cy="34" r="4" fill="#75c8ff" />
            </svg>

            <div className="cloud-nodes">
              {servers.map(({ name, role, cpu, ram, Icon }, index) => (
                <button type="button" className={`cloud-node${index === 1 ? " cloud-node--featured" : ""}`} data-cloud-node={name} key={name} aria-label={`Zobrazit ukázkové grafy serveru ${name}`} aria-expanded="false" aria-controls="cloud-metrics-panel">
                  <span className="cloud-node__top"><Icon aria-hidden="true" /><span className="cloud-node__led" /></span>
                  <small>{role}</small>
                  <strong>{name}</strong>
                  <span className="cloud-node__resources"><span>{cpu}</span><span>{ram}</span></span>
                  <span className="cloud-node__type">KVM VPS</span>
                </button>
              ))}
            </div>

            <div className="cloud-private-network"><span /><span /><span /><div><Network aria-hidden="true" /> Privátní síť</div></div>

            <div className="cloud-hypervisor">
              <div className="cloud-hypervisor__heading"><span className="cloud-hypervisor__icon"><Layers3 aria-hidden="true" /></span><div><strong>KVM / QEMU</strong><small>Plná virtualizace. Vlastní operační systém.</small></div><Cpu aria-hidden="true" /></div>
              <div className="cloud-hypervisor__resources"><span>vCPU<i /></span><span>Paměť<i /></span><span>Úložiště<i /></span></div>
            </div>
          </div>

          <section className="cloud-metrics" id="cloud-metrics-panel" hidden aria-labelledby="cloud-metrics-title" aria-describedby="cloud-metrics-description">
            <header className="cloud-metrics__header">
              <div><span className="cloud-metrics__eyebrow">Ukázka výkonu</span><h2 id="cloud-metrics-title"><span data-metrics-server>web-01</span></h2></div>
              <button type="button" data-metrics-back><ArrowLeft aria-hidden="true" /> Zpět na schéma</button>
            </header>
            <p id="cloud-metrics-description">Fiktivní data · ukázkový průběh za 60 minut</p>
            <div className="cloud-metrics__charts">
              {[
                { id: "cpu", label: "CPU", description: "Vytížení procesoru", Icon: Cpu },
                { id: "ram", label: "RAM", description: "Využitá paměť", Icon: Layers3 },
                { id: "net", label: "NET", description: "Síťový provoz", Icon: Network },
              ].map(({ id, label, description, Icon }) => (
                <section className={`cloud-metric cloud-metric--${id}`} data-metric={id} key={id} aria-labelledby={`cloud-metric-${id}`}>
                  <div className="cloud-metric__label"><Icon aria-hidden="true" /><h3 id={`cloud-metric-${id}`}>{label}</h3><span>{description}</span></div>
                  <strong className="cloud-metric__value" data-metric-value>—</strong>
                  <svg className="cloud-metric__graph" viewBox="0 0 240 100" preserveAspectRatio="none" role="img" aria-label={`${description} za posledních 60 minut, fiktivní data`}>
                    <path className="cloud-metric__grid" d="M0 1H240M0 50H240M0 99H240" />
                    <path className="cloud-metric__area" data-metric-area />
                    <path className="cloud-metric__line" data-metric-line pathLength="1" />
                  </svg>
                  <div className="cloud-metric__time"><span>−60 min</span><span>−30 min</span><span>Teď</span></div>
                </section>
              ))}
            </div>
          </section>
        </div>

        <div className="cloud-scene__footer">
          <figcaption id="cloud-scene-caption">Interaktivní ukázka cloudu</figcaption>
          <a href="/specifikace_rest_api.pdf"><Code2 aria-hidden="true" /> Ovládání přes REST API <ArrowUpRight aria-hidden="true" /></a>
        </div>
      </figure>
    </div>
  );
}
